import { isEmpty } from 'lodash'

export default (searchedBy, filters, keywords) => {
  if (!isEmpty(keywords)) {
    filters['keywords'] = keywords
    searchedBy.push(keywords)
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/tags/resources/filters/filterByKeywords.js